import { api } from "@/lib/axios";
import type {
  ApiResponse,
  CompanySearchRequest,
  CompanySearchResult,
  DispatchCompanyDetail,
  AddDispatchCompanyRequest,
  UpdateDispatchCompanyRequest,
  CargoCompanyNameItem,
  CargoCompanyDetail,
} from "../types/company.types";

export const searchDispatchCompanies = async (
  params: CompanySearchRequest,
): Promise<CompanySearchResult> => {
  const { data } = await api.post<ApiResponse<CompanySearchResult>>(
    "/api/Company/Admin/Search-Dispatch",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const getDispatchCompany = async (
  companyGuid: string,
): Promise<DispatchCompanyDetail> => {
  const { data } = await api.get<
    ApiResponse<{ dispatchCompany: DispatchCompanyDetail }>
  >(`/api/Company/Admin/Get-Dispatch-Company/${companyGuid}`);
  if (data.code !== 200) throw new Error(data.message);
  return data.result.dispatchCompany;
};

export const addDispatchCompany = async (
  params: AddDispatchCompanyRequest,
): Promise<{ companyGuid: string }> => {
  const { data } = await api.post<ApiResponse<{ companyGuid: string }>>(
    "/api/Company/Admin/Add-Dispatch-Company",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};

export const updateDispatchCompany = async (
  params: UpdateDispatchCompanyRequest,
): Promise<void> => {
  const { data } = await api.post<ApiResponse<null>>(
    "/api/Company/Admin/Update-Dispatch-Company",
    params,
  );
  if (data.code !== 200) throw new Error(data.message);
};

export const searchCargoCompanyNames = async (
  searchStr: string,
): Promise<CargoCompanyNameItem[]> => {
  const { data } = await api.get<
    ApiResponse<{ cargoCompanies: CargoCompanyNameItem[] }>
  >("/api/Company/Dispatch/Search-Cargo-Company-Names", {
    params: { searchStr },
  });
  if (data.code !== 200) throw new Error(data.message);
  return data.result.cargoCompanies;
};

export const getCargoCompany = async (
  companyGuid: string,
): Promise<CargoCompanyDetail> => {
  const { data } = await api.get<ApiResponse<CargoCompanyDetail>>(
    `/api/Company/Dispatch/Get-Cargo-Company/${companyGuid}`,
  );
  if (data.code !== 200) throw new Error(data.message);
  return data.result;
};
